import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";
import { SEND_LIST_MAPPER_COLLECTION } from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/controlroom/controlRoomMsgDefinitions";

export const requestListMapperCollection = () => {
    getGlobalStates().eventBus.sendMsg(SEND_LIST_MAPPER_COLLECTION);
};
